import script from "./popup-confirm-delete.vue?vue&type=script&setup=true&lang=js"
export * from "./popup-confirm-delete.vue?vue&type=script&setup=true&lang=js"

import "./popup-confirm-delete.vue?vue&type=style&index=0&id=65bfd25c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65bfd25c"]])

export default __exports__